module.exports = __webpack_public_path__ + "static/media/renhao.e5795ee0.png";